export default "__VITE_ASSET__IzNIte23__"